import {GroupsResponseType, IGroups} from "@/entity/groups/groups.types";

export default class Groups implements IGroups {
    id: number;
    name: string;
    constructor(data: GroupsResponseType) {
        this.id = data.id;
        this.name = data.name;
    }
}